import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInputClass;
function PinnedPlayerInput() {
  if (PinnedPlayerInputClass === VOID) {
    class $ {
      constructor(id, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails, pins) {
        badge = badge === VOID ? Absent_getInstance() : badge;
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.u72_1 = id;
        this.v72_1 = name;
        this.w72_1 = email;
        this.x72_1 = badge;
        this.y72_1 = callSignAdjective;
        this.z72_1 = callSignNoun;
        this.a73_1 = imageURL;
        this.b73_1 = avatarType;
        this.c73_1 = unvalidatedEmails;
        this.d73_1 = pins;
      }
      toString() {
        return 'PinnedPlayerInput(id=' + this.u72_1.toString() + ', name=' + this.v72_1 + ', email=' + this.w72_1 + ', badge=' + toString(this.x72_1) + ', callSignAdjective=' + this.y72_1 + ', callSignNoun=' + this.z72_1 + ', imageURL=' + toString(this.a73_1) + ', avatarType=' + toString(this.b73_1) + ', unvalidatedEmails=' + toString(this.c73_1) + ', pins=' + toString(this.d73_1) + ')';
      }
      hashCode() {
        var result = this.u72_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.v72_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.w72_1) | 0;
        result = imul(result, 31) + hashCode(this.x72_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.y72_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.z72_1) | 0;
        result = imul(result, 31) + hashCode(this.a73_1) | 0;
        result = imul(result, 31) + hashCode(this.b73_1) | 0;
        result = imul(result, 31) + hashCode(this.c73_1) | 0;
        result = imul(result, 31) + hashCode(this.d73_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinnedPlayerInput()))
          return false;
        if (!this.u72_1.equals(other.u72_1))
          return false;
        if (!(this.v72_1 === other.v72_1))
          return false;
        if (!(this.w72_1 === other.w72_1))
          return false;
        if (!equals(this.x72_1, other.x72_1))
          return false;
        if (!(this.y72_1 === other.y72_1))
          return false;
        if (!(this.z72_1 === other.z72_1))
          return false;
        if (!equals(this.a73_1, other.a73_1))
          return false;
        if (!equals(this.b73_1, other.b73_1))
          return false;
        if (!equals(this.c73_1, other.c73_1))
          return false;
        if (!equals(this.d73_1, other.d73_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinnedPlayerInput');
    PinnedPlayerInputClass = $;
  }
  return PinnedPlayerInputClass;
}
//region block: exports
export {
  PinnedPlayerInput as PinnedPlayerInput1hnlnl1bk4or8,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput.mjs.map
